export class TargetSet {
  constructor(context) {
    this.context = context;
  }
  get element() {
    return this.context.element;
  }
  get identifier() {
    return this.context.identifier;
  }
  get schema() {
    return this.context.schema;
  }
  has(targetName) {
    return this.find(targetName) != null;
  }
  find() {
    for (var _len = arguments.length, targetNames = new Array(_len), _key = 0; _key < _len; _key++) {
      targetNames[_key] = arguments[_key];
    }
    const selector = this._getSelectorForTargetNames(targetNames);
    return this.context.getElement(selector);
  }
  findAll() {
    for (var _len2 = arguments.length, targetNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      targetNames[_key2] = arguments[_key2];
    }
    const selector = this._getSelectorForTargetNames(targetNames);
    return this.context.getElements(selector);
  }
  _getSelectorForTargetNames(targetNames) {
    return targetNames.map(targetName => this._getSelectorForTargetName(targetName)).join(', ');
  }
  _getSelectorForTargetName(targetName) {
    const targetDescriptor = `${this.identifier}.${targetName}`;
    return attributeValueContainsToken(this.schema.elAttribute, targetDescriptor);
  }
}
function attributeValueContainsToken(attributeName, token) {
  return `[${attributeName}~="${token}"]`;
}